"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PersonalRegisterResult = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _personalRegisterActions = require("./personalRegisterActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GRID_SPACING = 2;

/**
 * 個人情報設定結果
 */
class PersonalRegisterResult extends _react.default.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const {
      onBack,
      getCodeName,
      intl,
      userInfo,
      entries
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      fixedWidth: true,
      title: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_PERSONAL_REGISTER_RESULT
      }),
      actions: [/*#__PURE__*/_react.default.createElement(_CButton.default, {
        negative: true,
        onClick: onBack,
        autoWidth: true
      }, intl.formatMessage({
        id: _labelConsts.LABEL.CORE_TO_RETURN_HOME
      }))]
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: GRID_SPACING
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.USERCUSTOM_SET_ACTION_MESSAGE
    }))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_FULL_NAME
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(userInfo.shainNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_COMPANY_NAME
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(userInfo.kaishaNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_ORGANIZATION_NAME
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(userInfo.soshikiNmFull)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: entries.workRenkeiFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.CORE_WORK_PLACE
      }) + intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_PERSONAL_INFO
      }) : entries.masterFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.CORE_WORK_PLACE
      }) + intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_MASTER_DATA_INFO
      }) : intl.formatMessage({
        id: _labelConsts.LABEL.CORE_WORK_PLACE
      }),
      indent: true
    }, entries.siteListProp === _personalRegisterActions.SITE_LIST_PROP_CODE.INPUT_LIST ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.siteOtherTdfkCd))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.siteOtherNm))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.workTdfkCd))), /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.siteBuildingNm))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_WORKPLACE_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.workUpdDt)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: entries.homeRenkeiFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HOME_PLACE
      }) + intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_PERSONAL_INFO
      }) : entries.masterFlg ? intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HOME_PLACE
      }) + intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_LINKAGE_MASTER_DATA_INFO
      }) : intl.formatMessage({
        id: _labelConsts.LABEL.CORE_HOME_PLACE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.homeTdfkCd))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_HOMEPLACE_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.homeUpdDt)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.CORE_OTHER_STAY_PLACE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(getCodeName(_CodeConsts.CODE.TDFK.KBN, entries.otherTdfkCd))))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_OTHERPLACE_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.otherUpdDt)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_1
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.mailAddress1)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_2
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.mailAddress2)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_3
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.mailAddress3)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "left"
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.USERCUSTOM_MAIL_ADDRESS_UPDATE_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(entries.otherMailUpdDt)))))));
  }
}
exports.PersonalRegisterResult = PersonalRegisterResult;
PersonalRegisterResult.propTypes = {
  // Parent
  onBack: _propTypes.default.func,
  // withCodeUtil
  getCodeName: _propTypes.default.func,
  intl: _propTypes.default.object,
  // State
  userInfo: _propTypes.default.object,
  entries: _propTypes.default.object
};
const mapStateToProps = state => {
  return {
    userInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    entries: state.personalRegister.entries
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, null)((0, _CodeUtil.withCodeUtil)(PersonalRegisterResult));